export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";